/**
 * Confine d'errore del widget: un bug dell'assistente non deve mai bloccare la
 * pubblicazione. Se qualcosa dentro lancia durante il render, il widget
 * scompare e il back-office continua a funzionare.
 */

import { Component, type ErrorInfo, type ReactNode } from "react";

interface Stato {
  rotto: boolean;
}

export class ConfineAssistente extends Component<{ children: ReactNode }, Stato> {
  state: Stato = { rotto: false };

  static getDerivedStateFromError(): Stato {
    return { rotto: true };
  }

  componentDidCatch(errore: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) console.error("Assistente alla trasparenza: widget disattivato per un errore", errore, info);
  }

  render(): ReactNode {
    return this.state.rotto ? null : this.props.children;
  }
}
